// extracted by mini-css-extract-plugin
export default {"wrapper":"JX7aay4qaf6KMrhYGuyT","icon":"yJwHyMoc0gqC5Fml9rs0","select":"bKyNpHwF33ddz0trH4xq"};